module.exports = __webpack_public_path__ + "img/mr_krabs_first_dollar.1c0dca62.jpg";